import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';

import { EPlatform } from '../../types/platform';

import * as styles from './DownloadAppBanner.css';

interface IDownloadAppBannerProps {
  url: string;
  platformType: EPlatform;
  onDownloadAppClick(): void;
  onMobileAppClick(): void;
}

export const DownloadAppBanner: React.FC<IDownloadAppBannerProps> = ({
  url,
  platformType,
  onDownloadAppClick,
  onMobileAppClick,
}) => {
  return (
    <div className={styles['banner']} data-testid="DownloadAppBanner">
      <div className={styles['image']}></div>
      <span className={styles['download-text']}>Приложение быстрее и удобнее</span>
      <LinkButton
        fullWidth
        href={url}
        onClick={onDownloadAppClick}
        data-testid={`${platformType === EPlatform.Android ? 'DownloadLinkGooglePlay' : 'DownloadLinkAppStore'}`}
      >
        Скачать приложение
      </LinkButton>
      <a
        href="/mobile-app/"
        target="_blank"
        data-testid="LinkToMobileApp"
        className={styles['link']}
        onClick={onMobileAppClick}
      >
        Подробнее
      </a>
    </div>
  );
};
